if (typeof QuickBuy !== 'function') {
  class QuickBuy extends HTMLElement {
    constructor() {
      super();

      // Product variant event listener for theme-specific logic.
      this.zIndex = 99;

      const hasProductItem = this.closest('[data-js-product-item]');

      this.productVariants = this.querySelector('product-variants');

      if (hasProductItem) {
        this.variantImages = this.querySelector(
          '[data-js-quick-buy-product-images]'
        );

        this.productImage = hasProductItem.querySelector(
          '[data-js-product-item-image]'
        );

        this.variantImagesSliders = this.hasAttribute(
          'data-variant-images-slider'
        );

        this.productSlider = hasProductItem.querySelector('css-slider');

        this._quickBuyPrice =
          this.productVariants.dataset.buyButtonPrice;

        this._defaultToFirstVariant =
          this.productVariants.hasAttribute('data-variant-required')
            ? false
            : true;
      }

      this.productVariants.addEventListener(
        'VARIANT_CHANGE',
        this.onVariantChangeHandler.bind(this)
      );

      this.onVariantChangeHandler({
        target: this.productVariants
      });

      if (this.variantImages) {
        setTimeout(() => {
          const imageObserver = new IntersectionObserver(
            (entries, observer) => {
              if (!entries[0].isIntersecting) {
                return;
              }

              this.variantImages
                .querySelectorAll('template')
                .forEach((element) => {
                  if (!element.dataset.init) {
                    this.#initVariantImage(element);
                  }
                });

              observer.unobserve(this);
            }
          );

          imageObserver.observe(this);
        }, 5000);
      }

      setTimeout(() => {
        this.querySelectorAll(
          '.product-variant__item--radio input'
        ).forEach((input) => {
          input.addEventListener('click', () => {
            const inputParent = input.closest(
              '.product-variant__item--radio'
            );

            inputParent.closest('.css-slider-holder').scrollTo({
              top: 0,
              left: inputParent.offsetLeft - 40,
              behavior: 'smooth'
            });

            if (
              inputParent.classList.contains(
                'product-variant__item--color'
              )
            ) {
              inputParent
                .closest('.product-variant')
                .querySelector('.product-variant__item-text-label')
                .textContent = input.value;
            }
          });
        });
      }, 1000);

      // Trigger cart popup/drawer.
      if (this.querySelector('[data-js-quick-buy-form]')) {
        this.querySelector('form').addEventListener('submit', (event) => {
          event.preventDefault();

          const submitButton = this.querySelector('[type="submit"]');

          submitButton.classList.add('working');

          window.handleAddToCart(
            this.#serializeForm(event.currentTarget),
            1,
            {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            () => {
              submitButton.classList.remove('working');
            }
          );
        });
      }

      // Update product-card details.
      setTimeout(() => {
        if (hasProductItem) {
          const cardPrice = hasProductItem.querySelector(
            '[data-js-product-item-price]'
          );

          const buttonPrice = this.querySelector(
            '[data-js-product-add-to-cart-text]'
          );

          const button = this.querySelector(
            '[data-js-product-add-to-cart]'
          );

          const productPrice = this.querySelector(
            '[data-js-quick-buy-product-price]'
          );

          new MutationObserver(() => {
            if (cardPrice) {
              cardPrice.innerHTML = productPrice.innerHTML;

              if (
                productPrice.querySelector('.product-price--original') &&
                productPrice.querySelector('.product-price--original')
                  .textContent !== ''
              ) {
                cardPrice.parentNode.classList.remove(
                  'product-item__price--empty'
                );
              } else {
                cardPrice.parentNode.classList.add(
                  'product-item__price--empty'
                );
              }
            }

            if (
              this.dataset.addToCartPrice === 'true' &&
              !button.classList.contains('disabled')
            ) {
              buttonPrice.innerHTML =
                `${buttonPrice.innerHTML} ` +
                `<span class="element--hide-on-small">- ` +
                `${productPrice.innerHTML}</span>`;
            }
          }).observe(productPrice, {
            attributes: false,
            childList: true,
            subtree: true
          });
        }

        if (this._defaultToFirstVariant) {
          if (
            hasProductItem.querySelector('[data-js-product-item-price]')
          ) {
            hasProductItem.querySelector(
              '[data-js-product-item-price]'
            ).innerHTML = hasProductItem.querySelector(
              '[data-js-product-default-price-data]'
            ).innerHTML;

            const buttonPrice = this.querySelector(
              '[data-js-product-add-to-cart-text]'
            );

            const button = this.querySelector(
              '[data-js-product-add-to-cart]'
            );

            const productPrice = this.querySelector(
              '[data-js-quick-buy-product-price]'
            );

            if (
              this.dataset.addToCartPrice === 'true' &&
              !button.classList.contains('disabled')
            ) {
              if (this.dataset.singleVariant !== 'true') {
                buttonPrice.innerHTML =
                  `${buttonPrice.innerHTML} ` +
                  `<span class="element--hide-on-small">- ` +
                  `${productPrice.innerHTML}</span>`;
              }
            }
          }

          this.querySelectorAll(
            '.product-variant__item--color [data-selected]'
          ).forEach((element) => {
            if (!element.hasAttribute('data-silent-selected')) {
              element
                .closest('.product-variant')
                .querySelector('.product-variant__item-text-label')
                .textContent = element.value;
            }
          });
        }
      }, 10);

      setTimeout(() => {
        if (!this._defaultToFirstVariant) {
          this.querySelectorAll(
            '.product-variant__item--color ' +
              '[data-product-url][data-selected]'
          ).forEach((element) => {
            if (!element.hasAttribute('data-silent-selected')) {
              element
                .closest('.product-variant')
                .querySelector('.product-variant__item-text-label')
                .textContent = element.value;
            }
          });

          if (
            parseInt(
              this.querySelector('product-variants').dataset.variants
            ) === 1
          ) {
            this.querySelector('product-variants').updateBuyButtons();
          }
        }
      }, 1);
    }

    onVariantChangeHandler(event) {
      const variant = event.target.currentVariant;

      if (variant) {
        if (this.variantImages) {
          if (variant.featured_media?.id) {
            const variantImage = this.variantImages.querySelector(
              `template[data-media-id="${variant.featured_media.id}"]`
            );

            if (variantImage) {
              if (!variantImage.dataset.init) {
                this.#initVariantImage(variantImage);
              }

              this.#showVariantImage(variant.featured_media.id);
            }
          }
        } else if (this.variantImagesSliders) {
          if (variant.featured_image != null && this.productSlider) {
            const variantImage = this.productSlider.querySelector(
              `.product-item__image-${variant.featured_image.id}`
            );

            if (variantImage) {
              this.productSlider.changeSlide(
                variantImage.dataset.index
              );
            }
          }
        }

        this.querySelectorAll('css-slider').forEach((slider) => {
          // slider.resetSlider(false, false);
        });
      }
    }

    #initVariantImage(template) {
      template.dataset.init = true;

      const image = template.content
        .querySelector('figure')
        .cloneNode(true);

      image.dataset.mediaId = template.dataset.mediaId;

      this.productImage.append(image);
    }

    #showVariantImage(id) {
      this.productImage
        .querySelector('.product-item__image-figure--on-top')
        ?.classList.remove('product-item__image-figure--on-top');

      this.productImage
        .querySelector(`[data-media-id="${id}"]`)
        .classList.add('product-item__image-figure--on-top');

      this.productImage.querySelector(
        `[data-media-id="${id}"] img`
      ).srcset = this.productImage.querySelector(
        `[data-media-id="${id}"] img`
      ).srcset;

      this.productImage.querySelector(
        `[data-media-id="${id}"]`
      ).style.zIndex = ++this.zIndex;
    }

    #serializeForm(form) {
      const values = [];

      Array.prototype.slice.call(form.elements).forEach((field) => {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        ) {
          return;
        }

        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach((option) => {
            if (!option.selected) {
              return;
            }

            values.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });

          return;
        }

        if (
          ['checkbox', 'radio'].indexOf(field.type) > -1 &&
          !field.checked
        ) {
          return;
        }

        values.push(
          encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(field.value)
        );
      });

      return values.join('&');
    }
  }

  if (typeof customElements.get('quick-buy') === 'undefined') {
    customElements.define('quick-buy', QuickBuy);
  }
}

if (!window.handleAddToCart) {
  window.handleAddToCart = (body, items, headers, callback) => {
    let alert = '';

    fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
      body,
      headers,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status == 422) {
          alert = document.createElement('span');
          alert.className = 'alert alert--error';
          alert.innerHTML = response.description;

          return fetch('?section_id=helper-cart');
        }

        return fetch('?section_id=helper-cart');
      })
      .then((response) => response.text())
      .then((text) => {
        if (alert !== '') {
          KROWN.functions.dispatchStandardEvent(
            'CartErrorEvent',
            document.body,
            {
              error:
                typeof alert === 'object'
                  ? alert.textContent
                  : alert
            }
          );
        } else {
          let lines = [];

          try {
            const contentType =
              (headers &&
                (headers['Content-Type'] ||
                  headers['content-type'])) ||
              '';

            if (contentType.indexOf('application/json') > -1) {
              lines = (JSON.parse(body).items || []).map((item) => ({
                merchandiseId: String(item.id),
                quantity: parseInt(item.quantity, 10) || 1
              }));
            } else {
              const params = new URLSearchParams(body);

              lines = [
                {
                  merchandiseId: params.get('id'),
                  quantity: parseInt(params.get('quantity'), 10) || 1
                }
              ];
            }
          } catch (error) {
            // Leave lines empty when the request body cannot be parsed.
          }

          if (lines.length) {
            KROWN.functions.dispatchStandardEvent(
              'CartLinesUpdateEvent',
              document.body,
              {
                action: 'add',
                context: 'product',
                lines,
                promise: Promise.resolve({ cart: null })
              }
            );
          }
        }

        let doNext = false;

        if (document.body.classList.contains('template-cart')) {
          doNext = 'page';
        } else {
          if (
            KROWN.settings.cart_action === 'overlay' &&
            document.getElementById('site-cart-sidebar')
          ) {
            doNext = 'drawer';
          } else if (
            KROWN.settings.cart_popup === 'true' &&
            document.getElementById('mini-cart-popup')
          ) {
            doNext = 'popup';
          } else {
            doNext = 'page';
          }
        }

        if (doNext === 'page') {
          window.location.href = KROWN.settings.routes.cart_url;
        } else {
          if (document.getElementById('site-cart-sidebar')) {
            const sectionInnerHTML = new DOMParser().parseFromString(
              text,
              'text/html'
            );

            const cartFormInnerHTML =
              sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;

            const cartSubtotalInnerHTML =
              sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

            const cartItems = document.getElementById('AjaxCartForm');

            cartItems.innerHTML = cartFormInnerHTML;
            cartItems.ajaxifyCartItems();

            document
              .querySelectorAll('[data-header-cart-count]')
              .forEach((element) => {
                element.innerHTML = document.querySelector(
                  '#AjaxCartForm [data-cart-count]'
                ).innerHTML;
              });

            if (document.getElementById('cart-recommendations-sidebar')) {
              document
                .getElementById('cart-recommendations-sidebar')
                .generateRecommendations();
            }

            if (alert !== '') {
              document
                .getElementById('AjaxCartForm')
                .querySelector('form')
                .prepend(alert);
            }

            document.getElementById('AjaxCartSubtotal').innerHTML =
              cartSubtotalInnerHTML;
          }

          if (doNext === 'drawer') {
            document.getElementById('site-cart-sidebar').show();
          } else {
            const miniCartPopup =
              document.getElementById('mini-cart-popup');

            if (items == 1) {
              miniCartPopup.querySelector(
                '[data-js-mini-cart-single]'
              ).style.display = 'block';

              miniCartPopup.querySelector(
                '[data-js-mini-cart-plural]'
              ).style.display = 'none';
            } else {
              miniCartPopup.querySelector(
                '[data-js-mini-cart-plural]'
              ).style.display = 'block';

              miniCartPopup.querySelector(
                '[data-js-mini-cart-plural]'
              ).innerHTML =
                KROWN.settings.locales.cart_added_items_count.replace(
                  '{{ count }}',
                  items
                );

              miniCartPopup.querySelector(
                '[data-js-mini-cart-single]'
              ).style.display = 'none';
            }

            miniCartPopup.show();

            if (miniCartPopup.dataset.hide != '0') {
              setTimeout(() => {
                miniCartPopup.hide();
              }, parseInt(miniCartPopup.dataset.hide));
            }
          }
        }
      })
      .catch((error) => {
        // Preserve the existing cart error handling.
      })
      .finally(() => {
        callback();
      });
  };
}

if (typeof QuickAddToCart !== 'function') {
  class QuickAddToCart extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('product-form')) {
        this.init();
      }
    }

    init() {
      this.querySelector('product-form').addEventListener(
        'add-to-cart',
        () => {
          let doNext = '';

          if (document.body.classList.contains('template-cart')) {
            doNext = 'page';
          } else {
            if (
              KROWN.settings.cart_action === 'overlay' &&
              document.getElementById('site-cart-sidebar')
            ) {
              doNext = 'drawer';
            } else if (
              KROWN.settings.cart_popup === 'true' &&
              document.getElementById('mini-cart-popup')
            ) {
              doNext = 'popup';
            } else {
              doNext = 'page';
            }
          }

          if (doNext === 'page') {
            window.location.href = KROWN.settings.routes.cart_url;
          } else {
            if (doNext === 'drawer') {
              document.getElementById('site-cart-sidebar').show();
            } else {
              const miniCartPopup =
                document.getElementById('mini-cart-popup');

              miniCartPopup.querySelector(
                '[data-js-mini-cart-single]'
              ).style.display = 'block';

              miniCartPopup.querySelector(
                '[data-js-mini-cart-plural]'
              ).style.display = 'none';

              miniCartPopup.show();

              if (miniCartPopup.dataset.hide != '0') {
                setTimeout(() => {
                  miniCartPopup.hide();
                }, parseInt(miniCartPopup.dataset.hide));
              }
            }
          }
        }
      );
    }
  }

  if (typeof customElements.get('quick-add-to-cart') === 'undefined') {
    customElements.define('quick-add-to-cart', QuickAddToCart);
  }
}

if (typeof QuickViewProduct !== 'function') {
  class QuickViewProduct extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('a')) {
        this.init();
      }
    }

    #initModalProduct() {
      this.quickViewModal
        .querySelector('.product-quick-view__close')
        .addEventListener('click', () => {
          this.quickViewModal.hide();
        });

      if (
        this.quickViewModal.querySelector('[data-js-product-form]')
      ) {
        this.quickViewModal
          .querySelector('[data-js-product-form]')
          .addEventListener('add-to-cart', () => {
            document
              .getElementById('site-cart-sidebar')
              ?.scrollTo({
                top: 0,
                behavior: 'smooth'
              });

            this.quickViewModal.hide();
          });
      }

      if (Shopify && Shopify.PaymentButton) {
        setTimeout(() => {
          Shopify.PaymentButton.init();
        }, 50);
      }

      const productVariants =
        this.quickViewModal.querySelector('product-variants');

      if (!productVariants._defaultToFirstVariant) {
        productVariants
          .querySelectorAll(
            '.product-variant__item--color ' +
              '[data-product-url][data-selected]'
          )
          .forEach((element) => {
            if (!element.hasAttribute('data-silent-selected')) {
              element
                .closest('.product-variant')
                .querySelector('.product-variant__item-text-label')
                .textContent = element.value;
            }
          });

        if (parseInt(productVariants.dataset.variants) === 1) {
          productVariants.updateBuyButtons();
        }
      }
    }

    init() {
      this.quickViewModal = null;

      this.querySelector('a').addEventListener('click', (event) => {
        event.preventDefault();

        if (!this.quickViewModal) {
          const target = event.currentTarget;

          target.classList.add('working');

          fetch(
            `${target.getAttribute('href')}` +
              `${target.getAttribute('href').includes('?') ? '&' : '?'}` +
              'view=quick-view'
          )
            .then((response) => response.text())
            .then((text) => {
              const quickViewHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#product-quick-view');

              const quickViewContainer = document.createElement('div');

              quickViewContainer.innerHTML = `
                <modal-box
                  id="modal-${target.dataset.id}"
                  class="modal modal--product"
                  data-options='{
                    "enabled": false,
                    "showOnce": false,
                    "blockTabNavigation": true
                  }'
                  tabindex="-1"
                  role="dialog"
                  aria-modal="true"
                >
                  <div class="container--medium">
                    <div class="modal-content" data-js-product-page>
                      <button
                        class="modal-close"
                        data-js-close
                        data-js-first-focus
                        style="position:absolute;margin:0;top:0;right:0"
                      >${window.KROWN.settings.symbols.close}</button>
                    </div>
                  </div>
                  <span class="modal-background" data-js-close></span>
                </modal-box>
              `;

              this.quickViewModal =
                quickViewContainer.querySelector('modal-box');

              document.body.appendChild(this.quickViewModal);

              this.quickViewModal.querySelector(
                '.modal-content'
              ).innerHTML = quickViewHTML.innerHTML;

              setTimeout(() => {
                this.#initModalProduct();
              }, 100);

              this.quickViewModal
                .querySelector('[data-js-product-page]')
                .addEventListener('reload', () => {
                  this.#initModalProduct();
                });

              if (!window.productPageScripts) {
                const scripts =
                  this.quickViewModal.querySelectorAll('script');

                scripts.forEach((element) => {
                  const script = document.createElement('script');

                  script.src = element.src;
                  document.body.append(script);

                  window.productPageScripts = true;
                });
              }

              setTimeout(() => {
                this.quickViewModal.show();
                target.classList.remove('working');
              }, 250);
            });
        } else {
          this.quickViewModal.show();
        }
      });
    }
  }

  if (typeof customElements.get('quick-view-product') === 'undefined') {
    customElements.define('quick-view-product', QuickViewProduct);
  }
}

if (!KROWN.productItemUpdateHelper) {
  KROWN.productItemUpdateHelper = (
    productItem,
    productId,
    html,
    skeleton
  ) => {
    const truncate = (string, max = 10) => {
      const words = string.trim().split(' ');
      const ellipsis = words.length > max ? '...' : '';

      return words.slice(0, max).join(' ') + ellipsis;
    };

    productItem.id = `product-item-${productId}`;

    // Update thumbnail.
    productItem.querySelector('.product-item__image').innerHTML =
      html.querySelector('.product-item__image').innerHTML;

    productItem
      .querySelectorAll('.product-item__image img[sizes]')
      .forEach((image) => {
        image.setAttribute(
          'sizes',
          skeleton.settings.product_image_sizes
        );
      });

    // Update inner content.
    productItem.querySelector('.product-item__text').innerHTML = '';

    skeleton.elements.forEach((element) => {
      const classNames = element.className;

      if (classNames) {
        const newElement = html.querySelector(
          '.' + classNames.split(' ').join('.')
        );

        if (newElement) {
          productItem
            .querySelector('.product-item__text')
            .append(newElement);

          if (classNames.includes('product-item__link')) {
            newElement.querySelector(
              '.product-item__link .button__text'
            ).textContent =
              skeleton.settings.product_link_button_label;
          } else if (classNames.includes('product-item__excerpt')) {
            if (
              skeleton.settings.product_description_excerpt_link !== true
            ) {
              newElement
                .querySelector('.product-item__excerpt-link')
                .remove();
            }

            newElement.querySelector(
              '.product-item__excerpt-text'
            ).textContent = truncate(
              newElement.querySelector(
                '.product-item__excerpt-text'
              ).textContent,
              skeleton.settings.product_description_excerpt_length
            );
          }
        }
      }
    });

    // Update badges.
    const newBadges = html.querySelector('.product-item__badges');

    const oldBadges = productItem.querySelector(
      '.product-item__badges'
    );

    if (newBadges && oldBadges) {
      oldBadges.innerHTML = newBadges.innerHTML;
    }

    // Reset some settings.
    if (skeleton.settings.defer_add === 'true') {
      productItem
        .querySelector('[data-js-product-add-to-cart]')
        .classList.remove(
          'button',
          'button--solid',
          'button--outline',
          'button--outline-hover-solid',
          'button--fullwidth',
          'button--loader',
          'button--move'
        );
    } else {
      productItem.querySelector('.defer-checkmark')?.remove();
    }

    if (
      skeleton.settings.show_add_to_cart_price &&
      productItem.querySelector('quick-buy')
    ) {
      productItem.querySelector(
        'quick-buy'
      ).dataset.addToCartPrice = 'true';
    }

    if (skeleton.settings.unavailable_variants !== 'hide') {
      if (skeleton.settings.unavailable_variants === 'show') {
        productItem
          .querySelector('product-variants')
          .setAttribute('data-hide-variants', 'true');

        productItem
          .querySelectorAll('[data-option-value-id]')
          .forEach((element) => {
            element.removeAttribute('disabled');
          });
      } else if (
        skeleton.settings.unavailable_variants === 'disable'
      ) {
        productItem
          .querySelector('product-variants')
          .setAttribute('data-hide-variants', 'disable');
      }

      productItem
        .querySelector('product-variants')
        .setAttribute(
          'data-unavailable-variants',
          skeleton.settings.unavailable_variants
        );

      productItem
        .querySelector('product-variants')
        .classList.remove('product-variants--hide-unavailable');

      productItem
        .querySelector('.product-variant__out-of-stock')
        ?.remove();
    }
  };
}

if (
  window.KROWN &&
  typeof KROWN.functions?.applyCartDiscountCode !== 'function'
) {
  KROWN.functions = KROWN.functions || {};

  /*
   * Preserve existing discount codes when applying a new code.
   * Refresh the cart and discount pills after the update.
   */
  const getCartDiscountCodes = async () => {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      if (!response.ok) {
        return [];
      }

      const cart = await response.json();

      return (cart.discount_codes || []).map((entry) => entry.code);
    } catch (error) {
      return [];
    }
  };

  const refreshCart = async () => {
    if (
      !document.getElementById('AjaxCartForm') ||
      typeof window.renderHelperCart !== 'function'
    ) {
      return;
    }

    try {
      const response = await fetch(
        `?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`
      );

      const sectionInnerHTML = window.renderHelperCart(
        await response.text()
      );

      const cartDiscounts = document.querySelector('cart-discounts');

      if (cartDiscounts) {
        cartDiscounts.refreshDiscounts(sectionInnerHTML);
      }
    } catch (error) {
      console.warn('Cart refresh could not complete:', error);
    }
  };

  KROWN.functions.applyCartDiscountCode = async (code) => {
    if (!code) {
      return;
    }

    try {
      const existingCodes = await getCartDiscountCodes();

      const codes = existingCodes.includes(code)
        ? existingCodes
        : [...existingCodes, code];

      const response = await fetch(
        KROWN.settings.routes.cart_update_url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript'
          },
          body: JSON.stringify({
            discount: codes.join(',')
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          `cart/update.js responded ${response.status}`
        );
      }

      const cart = await response.json();

      const applied = (cart.discount_codes || []).find(
        (entry) => entry.code === code
      );

      if (!applied || !applied.applicable) {
        console.warn(
          `Discount "${code}" was not applied — ` +
            "the code is invalid, expired, or this cart doesn't qualify for it."
        );
      }

      await refreshCart();
    } catch (error) {
      console.warn('Discount code could not be applied:', error);
    }
  };
}

/*
 * Gerovital:
 * - Mobile Buy + selected-variant price.
 * - Native desktop price suffix for custom Banner cards.
 * Native cart and variant logic stays intact.
 */
(() => {
  if (window.gvMobileBuyInstalled) {
    return;
  }

  window.gvMobileBuyInstalled = true;

  const initialized = new WeakSet();

  function initialize(quickBuy) {
    if (initialized.has(quickBuy)) {
      return;
    }

    const card = quickBuy.closest('[data-js-product-item]');

    const bannerBody = quickBuy.closest('[class*="__card-body"]');

    if (!card && !bannerBody) {
      return;
    }

    if (!quickBuy.querySelector('[data-js-quick-buy-form]')) {
      return;
    }

    const label = quickBuy.dataset.gvMobileBuyLabel;

    if (
      !label ||
      label.toLowerCase().includes('translation missing')
    ) {
      return;
    }

    initialized.add(quickBuy);

    const host = card || bannerBody;

    let scheduled = false;

    function setReady(element, ready) {
      if (
        element.classList.contains('gv-mobile-buy-ready') !== ready
      ) {
        element.classList.toggle('gv-mobile-buy-ready', ready);
      }
    }

    function synchronize() {
      const variants = quickBuy.querySelector('product-variants');

      const button = quickBuy.querySelector(
        '[data-js-product-add-to-cart]'
      );

      const nativeText = quickBuy.querySelector(
        '[data-js-product-add-to-cart-text]'
      );

      const source = quickBuy.querySelector(
        '[data-js-quick-buy-product-price]'
      );

      // Use the native renderer's current-price element.
      const price =
        source && source.querySelector('.product-price--original');

      let variant = variants && variants.currentVariant;

      if (typeof variant === 'undefined') {
        try {
          variant = JSON.parse(
            variants.querySelector('[data-js-variant-data]').textContent
          );
        } catch (error) {
          variant = null;
        }
      }

      const requiresSelection =
        variants &&
        variants.hasAttribute('data-variant-required') &&
        variants.noVariantSelectedYet !== false;

      const specialWording =
        (variants &&
          variants.hasAttribute('data-show-bundle-wording')) ||
        (nativeText &&
          nativeText.hasAttribute('data-show-preorder-wording'));

      const ready = Boolean(
        variants &&
          button &&
          nativeText &&
          variant &&
          variant.available &&
          !requiresSelection &&
          !specialWording &&
          !button.disabled &&
          !button.classList.contains('disabled') &&
          !button.classList.contains('ks-disabled') &&
          price &&
          price.textContent.trim()
      );

      if (button) {
        setReady(button, ready);
      }

      setReady(host, ready);

      if (!ready) {
        return;
      }

      let mobileText = button.querySelector(
        '[data-gv-mobile-buy-content]'
      );

      if (!mobileText) {
        mobileText = document.createElement('span');
        mobileText.className = 'button__text gv-mobile-buy-content';
        mobileText.setAttribute('data-gv-mobile-buy-content', '');
        button.appendChild(mobileText);
      }

      const cleanPrice = price.cloneNode(true);

      cleanPrice
        .querySelectorAll(
          '.visually-hidden, .sr-only, [hidden], [aria-hidden="true"]'
        )
        .forEach((element) => {
          element.remove();
        });

      const amount = cleanPrice.textContent
        .replace(/\s+/g, ' ')
        .trim()
        .replace(
          /^(?:sale\s+price|regular\s+price|price)\s*:\s*/i,
          ''
        );

      /*
       * Restore the native desktop price suffix for custom
       * Banner cards. Standard product cards stay unchanged.
       */
      if (
        bannerBody &&
        !card &&
        quickBuy.dataset.addToCartPrice === 'true'
      ) {
        let desktopPrice = nativeText.querySelector(
          '.element--hide-on-small'
        );

        if (!desktopPrice) {
          desktopPrice = document.createElement('span');
          desktopPrice.className = 'element--hide-on-small';
          nativeText.appendChild(desktopPrice);
        }

        const desktopSuffix = ` · ${amount}`;

        if (desktopPrice.textContent !== desktopSuffix) {
          desktopPrice.textContent = desktopSuffix;
        }
      }

      // Preserve the existing mobile label.
      const text = `${label} · ${amount}`;

      if (mobileText.textContent !== text) {
        mobileText.textContent = text;
      }
    }

    function schedule() {
      if (scheduled) {
        return;
      }

      scheduled = true;

      queueMicrotask(() => {
        scheduled = false;
        synchronize();
      });
    }

    new MutationObserver(schedule).observe(quickBuy, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    quickBuy.addEventListener('VARIANT_CHANGE', schedule, true);
    quickBuy.addEventListener('change', schedule);

    synchronize();
  }

  function scan(root) {
    if (!(root instanceof Element) && root !== document) {
      return;
    }

    if (root instanceof Element && root.matches('quick-buy')) {
      initialize(root);
    }

    root.querySelectorAll('quick-buy').forEach(initialize);
  }

  function start() {
    scan(document);

    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) {
            scan(node);
          }
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
